/**
 * Created by Terence on 2023/2/20 - 18:57
 * Description :
 */
import { defineStore } from "pinia";
import { storageKeys } from "@/constant/storage";
import { shouldRefreshToken } from "@/utils/authorize";
import ApiLogin from "@/apis/login";
import { isLinjieApp } from "@/utils/env-related";
import { getAppToken, getAppTokenVersion } from "@/utils/app-token";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import jb from "@frontend/effuse";

// 第一个参数是应用程序中 store 的唯一 id
export const useUsersStore = defineStore("user", {
  // 其它配置项
  state: () => {
    return {
      userInfo: JSON.parse(localStorage.getItem(storageKeys.USER_INFO) || "{}"),
      appUserStatus: "idle" as "idle" | "loading" | "ready" | "error",
      appUserError: "",
      appUserSyncId: 0,
      appUserTokenVersion: -1,
      expireTime: JSON.parse(
        localStorage.getItem(storageKeys.TOKEN_EXPIRE_AT) || "{}"
      ),
      name: "小猪课堂",
      age: 25,
      sex: "男",
    };
  },
  getters: {
    appUserReady(state): boolean {
      return (
        state.appUserStatus === "ready" &&
        state.appUserTokenVersion === getAppTokenVersion()
      );
    },
    // getAddAge: (state) => {
    //   return state.age + 100;
    // },
    getIsLogin(state): boolean {
      if (isLinjieApp()) return this.appUserReady && !!state.userInfo?.userId;
      // console.log('shouldRefreshToken===', shouldRefreshToken);
      return !!state.userInfo?.userId && !shouldRefreshToken();
    },
    // 可以这么使用 store.getAddAge(1100)
    getAddAge: (state) => {
      return (num: number) => state.age + num;
    },
    getNameAndAge(): string {
      return this.name + this.getAddAge; // 调用其它getter
    },
  },
  actions: {
    async syncAppUser(): Promise<boolean> {
      this.appUserStatus = "loading";
      this.appUserError = "";
      const syncId = ++this.appUserSyncId;
      const pending = getAppToken(true);
      const version = getAppTokenVersion();
      const isCurrent = () =>
        syncId === this.appUserSyncId && version === getAppTokenVersion();

      try {
        const token = await pending;
        if (!isCurrent()) return false;
        if (!token) {
          this.appUserError = "请先在 App 登录，再重新加载";
          if (jb.isApp()) {
            jb.login();
          } else {
            jb.navigateTo({ url: "congress://user/login" });
          }
          return false;
        }
        const res = await ApiLogin.getUserInfo({}, { timeout: 10000 });
        if (!isCurrent()) return false;
        const account = res.data?.account;
        const userId = account?.userId ?? account?.id;
        if (
          String(res.code) !== "0" ||
          (typeof userId !== "string" && typeof userId !== "number") ||
          !String(userId).trim()
        ) {
          throw new Error("无法获取用户信息，请重试");
        }
        this.setUserInfo({ ...account, userId: String(userId) });
        this.appUserTokenVersion = version;
        this.appUserStatus = "ready";
        return true;
      } catch {
        return false;
      } finally {
        // 包括同步期间 token 被其他请求的 401 失效；旧同步不改新状态。
        if (syncId === this.appUserSyncId && this.appUserStatus === "loading") {
          if (!this.appUserError) {
            this.appUserError = "登录信息同步失败，请重试";
          }
          this.appUserStatus = "error";
        }
      }
    },
    // 可以这么使用 store.saveName("我是小猪");
    saveName(name: string) {
      this.name = name;
    },
    handleLoginIfNot() {
      if (this.getIsLogin) return;
      window.location.href = `${location.origin}/login`;
    },
    setUserInfo(userInfo: any) {
      this.userInfo = userInfo;
      localStorage.setItem(storageKeys.USER_INFO, JSON.stringify(userInfo));
    },
  },
});
